import tooltip from "~/directives/tooltip/index";
import waterMarker from "~/directives/water-marker/index";

export default defineNuxtPlugin((nuxtApp) => {
  // 注册所有自定义指令
  nuxtApp.vueApp.directive("tooltip", tooltip);
  nuxtApp.vueApp.directive("waterMarker", waterMarker);
});
